let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("6f3t8")]).then(() => parcelRequire('ie54a'));